import * as React from "react";

/**
 * Composition (IME) tracking context shared between Dialog and form inputs.
 *
 * Lives in its own module (instead of dialog.tsx) so that ui/input and
 * ui/textarea — which ship in the critical entry chunk — do not pull the
 * whole @radix-ui/react-dialog tree (react-remove-scroll, focus-scope,
 * portal, ~45 KB source) into the entry bundle just to read this context.
 */
export const DialogCompositionContext = React.createContext<{
  isComposing: () => boolean;
  setComposing: (composing: boolean) => void;
  justEndedComposing: () => boolean;
  markCompositionEnd: () => void;
}>({
  isComposing: () => false,
  setComposing: () => {},
  justEndedComposing: () => false,
  markCompositionEnd: () => {},
});

export const useDialogComposition = () =>
  React.useContext(DialogCompositionContext);
